/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { getCookie } from "framework/libs/cookie";
import { TOKEN_SHOP } from "framework/store/constants";
import http from 'utilities/http';
import { isEmpty } from 'lodash';
import { Modal } from "react-bootstrap";
import Error from "../../error";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { useCart } from "../../../framework/store";
import { Loader } from "../../loader";

export default function HoSo({ }) {
    const [stateStore, actions] = useCart();
    const [state, _setState] = useState({
        addressUserList: [],
        dropItemAddress: "",
        modalAddress: false,
        modalState: "",
        countries: {},
        regions: [],
        currentRegion: "",
        currentCity: "",
        customer_id: "",
        loading: false
    });
    const { reset, register, handleSubmit, formState: { errors }, control, setValue, getValues } = useForm();
    const setState = (_state = {}) => {
        _setState((state) => ({
            ...state,
            ..._state
        }));
    };
    useEffect(() => { setState({ customer_id: stateStore?.cart?.customer?.id }); }, [stateStore]);
    useEffect(() => {
        const fetchDiaChi = async () => {
            setState({ loading: true });

            const res = await Promise.all([
                http('/rest/default/V1/customers/me', {}, { token: 'Bearer ' + getCookie(TOKEN_SHOP) }),
                http('/rest/V1/vne/directory', {}, {}),
            ]);
            setState({
                addressUserList: res[0].addresses,
                countries: res[1],
                regions: Object.keys(res[1]?.regions?.VN).map(item => {
                    return {
                        value: item,
                        code: res[1]?.regions.VN[item].code,
                        label: res[1]?.regions.VN[item].name,
                    };
                })
            });
            setState({ loading: false });
        };
        fetchDiaChi();
    }, []);
    useEffect(() => {
        if (state.modalAddress === false) {
            setState({
                dropItemAddress: "",
                modalState: ""
            });
        }
    }, [state.modalAddress]);
    const formatFormData = (data) => {
        const result = {
            customer_id: state?.customer_id,
            region: {
                region_code: data?.region.code,
                region: data?.region?.label,
                region_id: data?.region.value,
            },
            region_id: data?.region.value,
            country_id: "VN",
            street: [data.address],
            telephone: data.telephone,
            email: data.email,
            city: data?.city?.label,
            firstname: data.firstname,
            lastname: data.lastname,
            postcode: "1",
            custom_attributes: [{
                attribute_code: 'city_id',
                value: data?.city?.value
            }, {
                attribute_code: 'subdistrict',
                value: data?.district?.label
            }, {
                attribute_code: 'subdistrict_id',
                value: data?.district?.value
            }]
        };
        return result;
    };
    const saveAddress = async (data) => {
        if (state.modalState === "edit") {
            const body = {
                address: { ...formatFormData(data), customer_id: state.customer_id }
            };
            body.id = state?.dropItemAddress;
            body.address.id = state.dropItemAddress;
            setState({ loading: true });
            const res = await http('/rest/V1/vne/addresses', {}, {
                token: `Bearer ${getCookie(TOKEN_SHOP)}`,
                body,
                method: 'POST'
            });
            if (res) {
                toast.info('Chỉnh sửa địa chỉ thành công');
                setState({ addressUserList: state.addressUserList.map(x => x.id === res.id ? res : x) });
                setState({
                    modalAddress: false,
                    dropItemAddress: ""
                });
            } else { toast.error('Đã có lỗi xảy ra, vui lòng thử lại.'); }
            setState({ loading: false });
        } else {
            const body = {
                address: { ...formatFormData(data), customer_id: state.customer_id }
            };
            setState({ loading: true });
            const res = await http('/rest/V1/vne/addresses', {}, {
                token: `Bearer ${getCookie(TOKEN_SHOP)}`,
                body,
                method: 'POST'
            });
            if (res) {
                toast.info('Thêm địa chỉ thành công');
                state.addressUserList.push(res);
                setState({
                    modalAddress: false,
                });
            } else { toast.error('Đã có lỗi xảy ra.'); }
            setState({ loading: false });
        }
    };
    const deleteAddress = async (item) => {
        if (state.addressUserList?.length === 1) {
            toast.error('Không thể xóa địa chỉ cuối cùng!');
            setState({ dropItemAddress: "" });
            return;
        }
        if (item?.default_shipping === true) {
            toast.error('Không thể xóa địa chỉ mặc định!');
            setState({ dropItemAddress: "" });
            return;
        }
        setState({ loading: true });
        const deleted = await http(`/rest/V1/vne/addresses/${item.id}`, {}, {
            token: `Bearer ${getCookie(TOKEN_SHOP)}`,
            method: 'DELETE'
        });
        if (deleted) {
            toast.info('Xóa địa chỉ thành công');
            setState({ addressUserList: state.addressUserList.filter(i => i.id != item.id) });
        }
        setState({ loading: false });
    };
    const setAddressDefault = async (item) => {
        setState({ loading: true });
        const res = await http('/rest/V1/vne/addresses', {}, {
            token: `Bearer ${getCookie(TOKEN_SHOP)}`,
            body: {
                address: {
                    id: item.id,
                    default_shipping: true,
                    customer_id: state?.customer_id
                }
            },
            method: 'POST'
        });
        state.addressUserList.forEach(x => x.default_shipping = x.id === res.id ? true : false);
        setState({
            addressUserList: state.addressUserList,
            loading: false
        });
    };
    return (<>
        <Loader loading={state.loading} />
        <div className="address-form">
            <ul className="choose-address">
                {state?.addressUserList?.map(item => {
                    const address = [
                        item?.street,
                        item?.custom_attributes?.find(x => x.attribute_code === "subdistrict")?.value,
                        item?.city,
                        item?.region?.region
                    ].join(", ");
                    return <li className="active" key={item?.id}>
                        <strong className="user-name">{item?.firstname + " " + item?.lastname}</strong>
                        <span className="user-number">{item?.telephone}</span>
                        <p className="user-address">{address}</p>
                        {item?.default_shipping === true ?
                            <><img src="/images/icon-location-maps01.svg" /> Địa chỉ mặc định</>
                            : <button className="setup-default" onClick={() => { setAddressDefault(item); }}>Đặt làm địa chỉ mặc định</button>
                        }
                        <div className="setup-address">
                            <button className="btn-show" data-toggle="dropdown"
                                onClick={() => { setState({ dropItemAddress: state?.dropItemAddress === item?.id ? "" : item?.id }); }}>
                                <img className="svg" src="../images/icon-more.svg" align="" alt="" />
                            </button>
                            <div className={"dropdown-menu dropdown-menu-right " + (state.dropItemAddress === item?.id ? "d-block" : "d-none")} >
                                <a className="dropdown-item"
                                    onClick={() => {
                                        const region = state?.countries?.regions?.VN[item?.region?.region_id];
                                        const idCity = item.custom_attributes?.find(i => i.attribute_code === 'city_id')?.value || null;
                                        const idDistrict = item.custom_attributes?.find(i => i.attribute_code === 'subdistrict_id')?.value || null;
                                        const city = !isEmpty(state.countries.cities[item?.region?.region_id]) ? state.countries.cities[item?.region?.region_id][idCity] : '';
                                        const district = !isEmpty(state.countries.subdistricts[idCity]) ? state.countries.subdistricts[idCity][idDistrict] : '';
                                        reset({
                                            firstname: item?.firstname || '',
                                            lastname: item?.lastname || '',
                                            telephone: item?.telephone || '',
                                            region: item?.region?.region_id ? {
                                                value: item?.region?.region_id,
                                                label: region?.name,
                                                code: region?.code
                                            } : null,
                                            city: idCity ? {
                                                value: idCity,
                                                label: city.name,
                                                code: city.code
                                            } : null,
                                            district: idDistrict ? {
                                                value: idDistrict,
                                                label: district.name,
                                                code: district.code
                                            } : null,
                                            address: item.street.join(' '),
                                        });
                                        setState({
                                            modalAddress: true,
                                            modalState: "edit"

                                        });
                                    }}
                                >Chỉnh sửa</a>
                                <a className="dropdown-item" onClick={() => deleteAddress(item)}>Xóa </a>
                            </div>
                        </div>
                    </li>;
                })}
            </ul>
            <button className="btn-add-address"
                onClick={() => {
                    reset({
                        firstname: '',
                        lastname: '',
                        telephone: '',
                        region: null,
                        city: null,
                        district: null,
                        address: ""
                    });
                    setState({
                        modalAddress: true,
                        modalState: "new",
                    });
                }}
            ><img className="icon" src="/images/icon-discovery.svg" alt="" /> Thêm địa chỉ</button>
        </div>
        <Modal show={state.modalAddress} onHide={() => setState({ modalAddress: false })}>
            <form onSubmit={handleSubmit(saveAddress)}>
                <Modal.Header closeButton>
                    <h5 className="modal-title">{state.modalState === "edit" ? "Cập nhật " : "Thêm mới"} địa chỉ nhận hàng</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <img src="images/icon-close.png" alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className='modal-add-address-new'>
                    <div className="form-group mb-2">
                        <div className="row">
                            <div className="col-12 col-md-6 mb-2">
                                <label className="ttl font-weight-medium mb-1">Họ</label>
                                <input {...register("firstname", { required: "Điền họ người nhận" })} className="form-control"
                                    placeholder='Họ' type="text" />
                                <Error errors={errors} name="firstname" />
                            </div>
                            <div className="col-12 col-md-6 mb-2">
                                <label className="ttl font-weight-medium mb-1">Tên</label>
                                <input {...register("lastname", { required: "Điền tên người nhận" })} className="form-control"
                                    placeholder='Tên' type="text" />
                                <Error errors={errors} name="lastname" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-6">
                                <label className="ttl font-weight-medium mb-1">Số điện thoại</label>
                                <input className="form-control" placeholder='Số điện thoại' type="text"
                                    {...register("telephone", {
                                        required: "Điền Số điện thoại liên hệ",
                                    })} />
                                <Error errors={errors} name="telephone" />
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="ttl font-weight-medium mb-1">Địa chỉ nhận hàng</label>
                        <div className="row">
                            <div className="col-12 col-md-6 mb-2">
                                <Controller
                                    control={control}
                                    name="region"
                                    render={({
                                        field: { onChange, value },
                                    }) => (
                                        <Select
                                            {...register('region', { required: 'Chọn tỉnh thành phố' })}
                                            placeholder="Tỉnh/Thành phố"
                                            defaultValue={state.currentRegion}
                                            options={state.regions}
                                            onChange={(val) => {
                                                if (val.value !== getValues('region')?.value) {
                                                    onChange(val);
                                                    setValue('city', null);
                                                    setValue('district', null);
                                                    setState({ currentRegion: val, currentCity: null });
                                                }
                                            }}
                                            value={value}
                                        />
                                    )}
                                    rules={{ required: true }}
                                />
                                <Error errors={errors} name="region" />
                            </div>
                            <div className="col-12 col-md-6 mb-2">
                                <Controller
                                    control={control}
                                    name="city"
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { invalid, isTouched, isDirty, error },
                                        formState,
                                    }) => (
                                        <Select {...register('city', { required: 'Chọn quận/huyện' })}
                                            placeholder="Quận/Huyện"
                                            options={
                                                isEmpty(state.countries.cities[state.currentRegion?.value]) ?
                                                    [] :
                                                    Object.keys(state.countries.cities[state.currentRegion?.value]).map(item => {
                                                        return {
                                                            value: item,
                                                            label: state.countries.cities[state.currentRegion.value][item].name,
                                                            code: state.countries.cities[state.currentRegion.value][item].code
                                                        };
                                                    })}
                                            defaultValue={state.currentCity}
                                            value={value}
                                            onChange={(val) => {
                                                if (val.value !== getValues('city')?.value) {
                                                    setValue('district', null);
                                                    setState({ currentCity: val });
                                                    onChange(val);
                                                }
                                            }}
                                        />
                                    )}
                                    rules={{ required: true }}
                                />
                                <Error errors={errors} name="city" />

                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-md-6 mb-2">
                                <Controller
                                    control={control}
                                    name="district"
                                    render={({
                                        field: { onChange, onBlur, value, name, ref },
                                        fieldState: { invalid, isTouched, isDirty, error },
                                        formState,
                                    }) => (
                                        <Select
                                            placeholder="Phường/Xã" {...register('district', { required: 'Chọn phường/xã' })}
                                            options={isEmpty(state.currentCity) ? [] :
                                                Object.keys(state.countries.subdistricts[state.currentCity?.value]).map(item => {
                                                    return {
                                                        value: item,
                                                        label: state.countries.subdistricts[getValues('city')?.value] ?
                                                            state.countries.subdistricts[getValues('city')?.value][item]?.name : null,
                                                        code: state.countries.subdistricts[getValues('city')?.value] ?
                                                            state.countries.subdistricts[getValues('city')?.value][item]?.code : null
                                                    };
                                                })}
                                            value={value}
                                            onChange={(val) => {
                                                onChange(val);
                                            }}
                                        />
                                    )}
                                    rules={{ required: true }}
                                />
                                <Error errors={errors} name="district" />
                            </div>
                            <div className="col-12 col-md-6 mb-2">
                                <input className="form-control" placeholder="Số nhà, tên tòa nhà, tên đường,..."
                                    type="" {...register('address', { required: 'Điền địa chỉ nhà' })}
                                />
                                <Error errors={errors} name='address' />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary btn-ft-modal" type="submit">Lưu</button>
                </Modal.Footer>
            </form>
        </Modal>
    </>
    );
}